"use client";

import React, { useEffect } from 'react';
import { useToastStore } from '../../store/localapi';
import styles from './GlobalToast.module.css';

const ToastIcon = ({ type }: { type: 'success' | 'error' | 'info' }) => {
    const iconProps = {
        xmlns: "http://www.w3.org/2000/svg",
        height: "24px",
        viewBox: "0 -960 960 960",
        width: "24px",
        fill: "#FFFFFF"
    };

    switch (type) {
        case 'success':
            return <svg {...iconProps}><path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" /></svg>;
        case 'error':
            return <svg {...iconProps}><path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" /></svg>;
        case 'info':
            return <svg {...iconProps}><path d="m40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm302-40q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm-40-120h80v-200h-80v200Zm40-100Z" /></svg>;
        default:
            return null;
    }
};

export const GlobalToast = () => {
    const { isOpen, message, type, hideToast } = useToastStore();

    useEffect(() => {
        if (isOpen) {
            const timer = setTimeout(() => {
                hideToast();
            }, 3000); // Auto-hide after 3 seconds

            return () => clearTimeout(timer);
        }
    }, [isOpen, hideToast]);

    if (!isOpen) {
        return null;
    }

    return (
        <div className={`${styles.toastButtons} ${styles[type]}`}>
            <div className={styles.toastbody}>
                <div className={styles.toastIcon}>
                    <ToastIcon type={type} />
                </div>
                <div className={styles.toastErrMsg}>
                    <p className={styles.toastMessage}>{message}</p>
                </div>
            </div>
            <a href="#" onClick={(e) => { e.preventDefault(); hideToast(); }} className={styles.crossicon}>
                <span>&#10005;</span>
            </a>
        </div>
    );
};